var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRealEstateGrade = function SvgRealEstateGrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "real-estate-grade_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#real-estate-grade_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.587 0c8.907.456 14.326 10.238 9.747 18.054-4.52 7.72-15.669 7.912-20.452.348C-3.02 10.657 2.302.432 11.412 0h1.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.712 5.227c-5.322.24-8.331 6.281-5.25 10.67 2.793 3.98 8.763 3.775 11.304-.36 2.83-4.616-.671-10.562-6.054-10.322v.012Zm3.5 5.287-3.883 3.848c-.264.12-.468.06-.684-.108-.54-.612-1.282-1.175-1.798-1.798-.54-.648.192-1.38.84-.888l1.39 1.391 3.26-3.26a.543.543 0 0 1 .252-.12c.564-.096.923.455.624.934Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "real-estate-grade_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgRealEstateGrade as ReactComponent };